export enum FeatureList {
  ShakingRequestButton = 'shaking-request-button',
  DisableNearbyRoutes = 'disable-nearby-routes',
  AutoSuggest = 'th-b2c-autosuggest',
  JotformAlternativeUrl = 'jotform-alternative-url',
  GEO_MAP_NEW_ITERATION = 'th-geo-map-new-iteration',
  MULTIPLE_BOOKMARKS = 'th-multiple-bookmarks',
  cmsSearchThSorting = 'cms-search-th-sorting',
  cmsSearchThSortingB2b = 'cms-search-th-sorting-b2b',
  geoProductRecommenderView = 'th-geo-product-recommender-view',
  SplitPageviewEvent = 'split-pageview-event',
  stepsHowWeWork = 'th-steps-how-we-work',
  prodRecommenderFakeItem = 'th-prod-recommender-fake-item',
  mapAccessVisibility = 'th-map-access-visibility',
  appointmentForm = 'appointment-form', // BE feature
}
